import moment from 'moment';

export const formatDate = (dateString:string) => {
  const convertDate = Number(dateString)
  const date = moment(convertDate).format('DD/MM/YYYY hh:mm')
  console.log("date",date)
  return date
};